// src/navigation/publicServiceRoutes.js

export const serviceRoutes = Object.freeze([
  {
    id: 'services-overview',
    label: 'Services Overview',
    shortLabel: 'Overview',
    path: '/services',
  },
  {
    id: 'perceptual-skill-development',
    label: 'Perceptual Skill Development',
    path: '/perceptual-skill-development',
  },
  {
    id: 'institutional-programs',
    label: 'Institutional Programs',
    path: '/institutional-programs',
  },
  {
    id: 'perceptual-research-infrastructure',
    label: 'Perceptual Research Infrastructure',
    path: '/perceptual-research-infrastructure',
  },
  {
    id: 'perceptual-data-annotation',
    label: 'Perceptual Data Annotation',
    path: '/perceptual-data-annotation',
  },
  {
    id: 'access-and-pricing',
    label: 'Access & Pricing',
    path: '/access-and-pricing',
  },
]);

export const serviceLandingRoutes = Object.freeze(
  serviceRoutes.filter((route) => (
    route.id !== 'services-overview' &&
    route.id !== 'access-and-pricing'
  ))
);

export const serviceRoutePaths = Object.freeze(
  serviceRoutes.map((route) => route.path)
);

export const serviceRoutesById = Object.freeze(
  serviceRoutes.reduce((routesById, route) => {
    routesById[route.id] = route;
    return routesById;
  }, {})
);

export function isServiceRoutePath(pathname = '') {
  return serviceRoutePaths.some((path) => (
    pathname === path || pathname.startsWith(`${path}/`)
  ));
}
